import { auth } from "@/config/firebase";

const REGION = "southamerica-east1";
const PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID as string;

function getFunctionUrl(name: string): string {
  return `https://${REGION}-${PROJECT_ID}.cloudfunctions.net/${name}`;
}

export async function callFunction<T = unknown>(
  name: string,
  data?: unknown
): Promise<T> {
  const user = auth.currentUser;
  let token: string | null = null;

  if (user) {
    token = await user.getIdToken();
  }

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(getFunctionUrl(name), {
    method: "POST",
    headers,
    body: JSON.stringify({ data: data ?? {} }),
  });

  const json = await response.json();

  if (!response.ok) {
    throw new Error(json.error || `Erro ${response.status}`);
  }

  return json.result as T;
}
